/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   รายงานการเตรียมการและผสม (ห้องเคี่ยว)

   1 หน้า A4 = 2 ตารางขั้นตอนการผลิต (เหมือนฟอร์มกระดาษเดิม)
   ช่อง Batch__ และช่องตรวจเครื่องจักร เว้นว่างให้เขียนมือหน้างาน
============================================================ */
import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PdDocMeta from "../pd-common/PdDocMeta";
import { Modal, Button } from "antd";
import { PiPrinterFill } from "react-icons/pi";

import logo from "../../../assets/images/logo_nsf.png";
import ProductionOrderService from "../../../service/ERP/ProductionOrder.service";
import "./pd-curing-room.css";

const pdService = ProductionOrderService();
const PAGE_STYLE_ID = "pd-curing-print-page";

/* จำนวนคอลัมน์ Batch ในตารางขั้นตอนการผลิต */
const BATCH_COLS = 5;
/* ตารางขั้นตอนการผลิตต่อ 1 หน้า */
const TABLES_PER_PAGE = 2;

/* รายการเครื่องจักรที่ต้องตรวจก่อน/หลังใช้งาน */
/* 2 แถวว่างไว้เขียนชื่อเครื่องเอง (แถวละ 1 คำอธิบาย ✓ / ✕) */
const MACHINES = ["", ""];

const wnum = (v) =>
  Number(v || 0) > 0
    ? Number(v).toLocaleString("en-US", {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })
    : "";

/* ตารางตรวจเครื่องจักร — ทุกช่องเว้นว่างให้ติ๊กมือ */
function MachineTable() {
  return (
    <table className="cr-tbl cr-machine">
      <colgroup>
        <col style={{ width: "16%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "10%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <thead>
        <tr>
          <th rowSpan={2} className="cr-legend-cell" />
          <th rowSpan={2}>รายการ</th>
          <th colSpan={2}>จุดขันแน่น</th>
          <th colSpan={2}>ก่อนใช้งาน</th>
          <th colSpan={2}>หลังใช้งาน</th>
        </tr>
        <tr>
          <th>น็อตยึด (ตัว)</th>
          <th>ใบมีด</th>
          <th>ความสะอาด</th>
          <th>สภาพเครื่อง</th>
          <th>ความสะอาด</th>
          <th>สภาพเครื่อง</th>
        </tr>
      </thead>
      <tbody>
        {MACHINES.map((m, i) => (
          <tr key={i}>
            <td className="cr-legend">
              {i === 0 ? "✓ = ปกติ/สะอาด" : i === 1 ? "✕ = ไม่ปกติ/ไม่สะอาด" : ""}
            </td>
            <td className="l">{m}</td>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/* ตารางขั้นตอนการผลิต 1 ชุด */
function StepTable({ steps }) {
  return (
    <table className="cr-tbl cr-step">
      <colgroup>
        <col style={{ width: "15%" }} />
        <col style={{ width: "17%" }} />
        <col style={{ width: "12%" }} />
        {Array.from({ length: BATCH_COLS }).map((_, i) => (
          <col key={i} style={{ width: `${56 / BATCH_COLS}%` }} />
        ))}
      </colgroup>
      <thead>
        <tr>
          <th rowSpan={2}>
            รหัสวัตถุดิบ/
            <br />
            ส่วนผสม
          </th>
          <th rowSpan={2}>การเคี่ยว/ผสม</th>
          <th colSpan={1 + BATCH_COLS}>ตรวจสอบ</th>
        </tr>
        <tr>
          <th>ค่าควบคุม</th>
          {Array.from({ length: BATCH_COLS }).map((_, i) => (
            <th key={i}>Batch____</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {steps.map((g, gi) => (
          <Fragment key={`g-${gi}`}>
            <tr className="cr-grouprow">
              <td colSpan={3} className="c">
                กลุ่มที่ {g.stepno} {g.remark || ""}
              </td>
              {Array.from({ length: BATCH_COLS }).map((_, i) => (
                <td key={i} />
              ))}
            </tr>
            {(g.items || []).map((m, mi) => (
              <tr key={`g-${gi}-${mi}`}>
                <td className="c">{m.mat_code}</td>
                <td className="l">{m.mat_name}</td>
                <td className="r">{wnum(m.value)}</td>
                {Array.from({ length: BATCH_COLS }).map((_, i) => (
                  <td key={i} />
                ))}
              </tr>
            ))}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default function PdCuringRoomPrintPreview() {
  const { code } = useParams();
  const [forms, setForms] = useState([]);

  const handlePrint = () => window.print();

  useEffect(() => {
    let style = document.getElementById(PAGE_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = PAGE_STYLE_ID;
      style.media = "print";
      style.innerHTML = "@page { size: A4 portrait; margin: 8mm; }";
      document.head.appendChild(style);
    }
    return () => {
      const s = document.getElementById(PAGE_STYLE_ID);
      if (s) s.remove();
    };
  }, []);

  useEffect(() => {
    pdService
      .curingRoom(code)
      .then((res) => setForms(res.data?.data?.forms || []))
      .catch((err) => {
        Modal.error({
          title: "Error",
          content: err.response?.data?.message || "โหลดข้อมูลไม่สำเร็จ",
          onOk: () => window.close(),
        });
      });
  }, [code]);

  return (
    <div className="page-show" id="pd-curing">
      <div className="doc-wrapper">
        <div className="print-bar no-print">
          <Button
            className="bn-center bg-blue-400"
            onClick={handlePrint}
            icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
          >
            PRINT
          </Button>
        </div>

        {forms.map((f, fi) => (
          <section className="print-page" key={`${f.fg_code}-${fi}`}>
            <div className="cr-head">
              <img src={logo} alt="" className="cr-logo" />
              <div className="cr-title">
                <p className="cr-company">บริษัทไนน์สตาร์ฟู้ด จำกัด</p>
                <p className="cr-doc">รายงานการเตรียมและผสม (ห้องเคี่ยว)</p>
              </div>
            </div>

            <PdDocMeta form={f} date={dayjs().format("DD/MM/YYYY")} />

            <div className="cr-section">ตรวจเครื่องจักร</div>
            <MachineTable />

            <div className="cr-section">ขั้นตอนการผลิต</div>
            {Array.from({ length: TABLES_PER_PAGE }).map((_, i) => (
              <StepTable key={i} steps={f.steps || []} />
            ))}

            {/* footer เหมือนห้องสารส่วนผสม : ลายเซ็น + เลขหน้า ชิดล่างกระดาษ */}
            <div className="cr-foot">
              <div className="cr-sign">
                <span>ผู้จ่าย_______________</span>
                <span>ผู้ตรวจสอบ_______________</span>
              </div>
              <div className="cr-pageno">
                <span>{code}</span>
                <span>หน้า {fi + 1} / {forms.length}</span>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
